import { render, staticRenderFns } from "./DispensingModalConfirmComponent.vue?vue&type=template&id=3b254248"
import script from "./DispensingModalConfirmComponent.vue?vue&type=script&lang=js"
export * from "./DispensingModalConfirmComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports